/* Copyright 2015-2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';
   angular.module('com.vmware.platform.ui')
         .controller('SummaryViewController', SummaryViewController);

   SummaryViewController.$inject = [
      '$scope',
      '$timeout',
      'extensionService',
      'i18nService',
      'persistenceService',
      'summaryService',
      'vcH5ConstantsService',
      'configurationService',
      'dataService'
   ];

   function SummaryViewController(
         $scope,
         $timeout,
         extensionService,
         i18nService,
         persistenceService,
         summaryService,
         vcH5ConstantsService,
         configurationService,
         dataService
   ) {
      $scope.i18n = i18nService.getString;
      var self = this;
      var delayHandler = null;
      var SUMMARY_VIEW_STATUS_UID = 'com.vmware.usersetting.summaryview.status';
      var SUMMARY_VIEW_CATEGORY = 'com.vmware.usersetting.summaryview';
      self.loading = false;
      self.isPodVM = false;
      self.isVmSummaryView = false;
      self.showVmSummaryToggle = false;
      self.vmViewLoading = false;
      self.isVmView = $scope._view && summaryService.isVmView($scope._view.contentSpec.metadata.resourceBundle);
      self.isVmTemplate = false;
      self.podVMProperty = 'isPodVM';
      self.vmTemplateProperty = 'config/template';
      self.isVmManagedByWcp = false;
      self.isVmManagedByWcpProperty = 'isVmManagedByWcp';

      self.$onInit = function () {

         if (self.objectId && self.isVmView) {
            self.vmViewLoading = true;
            checkForPodVMAndVmTemplate(self.objectId)
                  .then(displayVmSummaryView);
         } else {
            activate();
         }
      };

      self.$onDestroy = function () {
         if (delayHandler) {
            $timeout.cancel(delayHandler);
         }
      };

      self.newSummaryTitle = i18nService.getString('Common', 'summary.newSummary.title');

      self.toggleNewSummary = function () {
         persistenceService.setData(
               SUMMARY_VIEW_STATUS_UID,
               angular.toJson({
                  showSummaryStatus: !self.isVmSummaryView
               }),
               {},
               SUMMARY_VIEW_CATEGORY);
         self.isVmSummaryView = !self.isVmSummaryView;

         // if its portlet's summary view
         if (!self.isVmSummaryView) {
            // get portlet VM Summary data
            activate();
            // show toggle button
            self.showVmSummaryToggle = true;
         }
      };

      function activate() {
         // self.objectId, viewId and metadata are passed as @Input params in migration mode
         if (!h5.ngMigrationEnabled) {
            self.objectId = ($scope._route ? $scope._route.objectId : null);
            self.viewId = $scope._view.$id;
            self.contentSpec = $scope._view.contentSpec;
         } else {
            self.contentSpec = { metadata: self.metadata };
         }

         self.portletOptions = {
            portlets: [],
            extensionId: self.viewId
         };

         $scope.$on(vcH5ConstantsService.MODEL_CHANGED_EVENT, function (event, objectChangeInfo) {
            if (self.objectId === objectChangeInfo.objectId) {
               evaluatePortlets();
            }
         });

         $scope.$on(vcH5ConstantsService.DATA_REFRESH_INVOCATION_EVENT, evaluatePortlets);
         evaluatePortlets();
      }

      function evaluatePortlets() {
         if (self.portletOptions.portlets.length === 0) {
            delayHandler = $timeout(function () {
               self.loading = true;
            }, 1000);
         }
         extensionService.getHostedExtensions(self.viewId, self.objectId)
               .then(function (portletSpecs) {
                  recreatePortlets(portletSpecs);
                  if (delayHandler) {
                     $timeout.cancel(delayHandler);
                  }
                  delayHandler = null;
                  self.loading = false;
               });
      }

      function recreatePortlets(portletSpecs) {
         var newPortlets = summaryService.createPortlets(portletSpecs, self.objectId);
         var oldPortlets = self.portletOptions.portlets;
         var updatedPortlets = summaryService.updatePortlets(newPortlets, oldPortlets);
         // reference equality is fine here
         if (updatedPortlets === oldPortlets) {
            // nothing changed, do not rebind
            return;
         }
         self.portletOptions.portlets = updatedPortlets;
      }

      function displayVmSummaryView() {
         var conditionObj = {
            key: 'uid',
            op: '=',
            value: SUMMARY_VIEW_STATUS_UID
         };
         // if pod vm no need to check vm summary toggle button status
         if (self.isPodVM) {
            self.vmViewLoading = false;
            return;
         }

         persistenceService.getData(conditionObj).then(function (showSummaryStatus) {
            // check for new summary
            if (showSummaryStatus && showSummaryStatus.length && showSummaryStatus[0].value) {
               var showSummary = angular.fromJson(showSummaryStatus[0].value);
               if (showSummary && showSummary.showSummaryStatus) {
                  self.isVmSummaryView = true;
                  self.vmViewLoading = false;
                  return;
               }
            }

            // its portlet summary view - get portlet VM Summary data
            activate();
            self.showVmSummaryToggle = true;
            self.vmViewLoading = false;
         });
      }

      function checkForPodVMAndVmTemplate(objectId) {
         return dataService.getProperties(objectId, [
               self.podVMProperty, self.vmTemplateProperty, self.isVmManagedByWcpProperty
         ])
               .then(function (data) {
                  if (data[self.podVMProperty]) {
                     self.isPodVM = true;
                  }
                  if (data[self.vmTemplateProperty]) {
                     self.isVmTemplate = true;
                  }
                  if (data[self.isVmManagedByWcpProperty]) {
                     self.isVmManagedByWcp = true;
                  }
               });
      }
   }
})();
